// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import { IHttpResponse } from 'app_types/httpTypes'
import { IForumHttpResponse } from 'app_types/admin/forum/forumTypes'
// @end

class ForumService {
	private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
  	this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async list(params: any = {}) {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/forum/forum`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  insertOrUpdate = async (forumData: any, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: IForumHttpResponse
    const formData = new FormData()

    Object.keys(forumData).map((key: string) => {
      if (typeof forumData[key] === 'object' && !!forumData[key][0]?.name && !!forumData[key][0].type) {
        formData.append(key, forumData[key][0])
      } else if (typeof forumData[key] === 'object' && !(forumData[key] instanceof Array)) {
        formData.append(key, JSON.stringify(forumData[key]))
      } else {
        formData.append(key, forumData[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/forum/forum/${action}`,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.forum
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getOne = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IForumHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/admin/forum/forum/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.forum
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/admin/forum/forum/delete/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getFeaturedForums = async () => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/forum/fetch-featured-forums`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getRelatedForums = async (params: {forum: string}) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/data/forum/${params.forum}/fetch-related-forums`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

}

export default ForumService
